module.exports = __webpack_public_path__ + "img/suksma.56146826.png";